<!-- template html -->
<template>
    <div v-if="displayLoaderToLogin" class="gt-groupcard-loader" style="z-index: 99999999;">
        <img :src="$getAssetUrlPlugin('siteres/gt-loader.gif')" alt="Loading" />
    </div>
    <!-- gtSignUp Modal -->
    <div class="modal fade gt-md-modal" id="signup" tabindex="-1" aria-labelledby="gtSignUp" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog mt-4 modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header p-0 border-0">
                    <button type="button" class="close p-2 mb-0 mr-2 ml-auto mt-0" data-dismiss="modal" aria-label="Close" @click="closemodal();">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 1L7 7L13 13" stroke="#1E2437" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M1 13L7 7L1 1" stroke="#1E2437" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>

                <div class="access-modal">
                    <h4>Sign up to continue</h4>
                    <div class="auth-flag us-flag">
                        <p>You are signing up to GroupTogether US. <br /> If you are in Australia <a href="https://app.grouptogether.com/account/register">click here</a> </p>
                    </div>
                    <!-- auth-flag -->
                    <div class="social-access">
                        <a href="Identity/account/termsandconditions?Provider=Facebook">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
                                <linearGradient id="Ld6sqrtcxMyckEl6xeDdMa" x1="9.993" x2="40.615" y1="9.993" y2="40.615" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#2aa4f4" />
                                    <stop offset="1" stop-color="#007ad9" />
                                </linearGradient>
                                <path fill="#1778f2" d="M24,4C12.954,4,4,12.954,4,24s8.954,20,20,20s20-8.954,20-20S35.046,4,24,4z" />
                                <path fill="#fff"
                                      d="M26.707,29.301h5.176l0.813-5.258h-5.989v-2.874c0-2.184,0.714-4.121,2.757-4.121h3.283V12.46 c-0.577-0.078-1.797-0.248-4.102-0.248c-4.814,0-7.636,2.542-7.636,8.334v3.498H16.06v5.258h4.948v14.452 C21.988,43.9,22.981,44,24,44c0.921,0,1.82-0.084,2.707-0.204V29.301z" />
                            </svg>

                            Sign up with Facebook
                        </a>
                        <a href="Identity/account/termsandconditions?Provider=Google">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
                                <path fill="#fbc02d"
                                      d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12	s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20	s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" />
                                <path fill="#e53935" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039	l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" />
                                <path fill="#4caf50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36	c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" />
                                <path fill="#1565c0"
                                      d="M43.611,20.083L43.595,20L42,20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571	c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z" />
                            </svg>

                            Sign up with Google
                        </a>
                    </div>
                    <!-- social-access -->

                    <div class="gt-form-main">
                        <h2> <span>Sign up with email</span> </h2>

                        <input type="hidden" id="volSignupId" name="volSignupId" value="0" />
                        <div class="gt-form-group">
                            <div class="form-group mt-form mb-0">
                                <input v-model="reg_Email" dirname="" class="form-control border0bottom" type="text" autocomplete="off" name="reg_Email" id="email" placeholder="Email">
                                <ErrorMessage name="email" class="text-danger" />
                            </div>
                            <div class="form-group mt-form mb-0">
                                <input v-model="reg_FName" class="form-control border0topbottom" type="text" autocomplete="off" name="regFName" id="reg_FName" placeholder="First Name">

                            </div>
                            <div class="form-group mt-form mb-0">
                                <input v-model="reg_LName" class="form-control border0topbottom" type="text" autocomplete="off" name="regLName" id="reg_LName" placeholder="Last Name">

                            </div>

                            <div class="form-group mt-form mb-0">
                                <input v-model="reg_Password" class="form-control border0topbottom password-field" type="password" autocomplete="off" name="reg_Password" id="reg_Password" placeholder="Password">
                                <!--@*<input type="password" class="form-control border0top password-field" name="password" value="" placeholder="Create a password">*@-->
                                <span toggle=".password-field" class="far fa-eye field-icon toggle-password" @click="switchVisibilitySignup"></span>
                            </div>
                            <div class="form-group mt-form mb-0">
                                <input v-model="reg_CPassword" class="form-control border0top password-field" type="password" autocomplete="off" name="reg_CPassword" id="reg_CPassword" placeholder="Confirm Password">

                            </div>
                            <div id="div_ErrorReg"></div>
                            <input type="hidden" value="@ViewBag.PageName" id="PageName" />

                            <div class="mt-35">
                                <button @click="Validate_Registration" class="theme-btn-lite" value="Create account"> Create account </button>
                            </div>

                        </div>


                    </div>
                    <!-- gt-form-main -->

                    <div class="gt-form-footer">
                        <p class="gt-form-terms">
                            By signing up via Google, Facebook or email,  <br />I agree to GroupTogether’s <a href="https://www.grouptogether.com/terms">Terms</a> & <a href="https://www.grouptogether.com/privacy">Privacy Policy.</a>
                        </p>
                        <!--<p class="signin text-center mt-4 mb-0">Have an account? <a data-dismiss="modal" id="Signup" data-target="#signin" href='#' onclick="SignInModal()">Log in</a> </p>-->

                        <p class="signin text-center mt-4 mb-0">Have an account?  <a data-dismiss="modal" id="Signup" data-toggle="modal" data-target="#signin" href='#'>Log in</a> </p>
                    </div>
                    <!-- gt-form-footer -->
                </div>

            </div>
        </div>
    </div>

    <div class="modal fade" id="signin" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content gt-login-modal modal-content-radius">
                <div class="modal-header p-0 border-0">
                    <button type="button" class="close p-2 mb-0 mr-2 ml-auto mt-0" data-dismiss="modal" aria-label="Close" @click="closemodal();">

                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 1L7 7L13 13" stroke="#1E2437" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M1 13L7 7L1 1" stroke="#1E2437" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </button>
                </div>
                <p class="modal-title" id="SuccessMessage" style="font-size:17px"></p>
                <p class="modal-title" id="SuccessMessage1" style="font-size:17px"></p>
                <h5 class="modal-title Sigin" id="staticBackdropLabel">Log in to continue</h5>
                <div class="modal-body">
                    <div class="auth-flag us-flag">
                        <p>You are logging into GroupTogether US. <br /> If you are in Australia <a href="https://app.grouptogether.com/account/signin">click here</a> </p>
                    </div>
                    <!-- auth-flag -->
                    <div class="social-access">
                        <a id="facebookmodal" @click="Showpope" href="Identity/account/ExternalLogin?Provider=Facebook" target="_top">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
                                <linearGradient id="Ld6sqrtcxMyckEl6xeDdMa" x1="9.993" x2="40.615" y1="9.993" y2="40.615" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#2aa4f4" />
                                    <stop offset="1" stop-color="#007ad9" />
                                </linearGradient>
                                <path fill="#1778f2" d="M24,4C12.954,4,4,12.954,4,24s8.954,20,20,20s20-8.954,20-20S35.046,4,24,4z" />
                                <path fill="#fff"
                                      d="M26.707,29.301h5.176l0.813-5.258h-5.989v-2.874c0-2.184,0.714-4.121,2.757-4.121h3.283V12.46 c-0.577-0.078-1.797-0.248-4.102-0.248c-4.814,0-7.636,2.542-7.636,8.334v3.498H16.06v5.258h4.948v14.452 C21.988,43.9,22.981,44,24,44c0.921,0,1.82-0.084,2.707-0.204V29.301z" />
                            </svg>

                            LOG IN with Facebook
                        </a>
                        <a id="googlemodal" @click="Showpope" href="Identity/account/ExternalLogin?Provider=Google" target="_top">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
                                <path fill="#fbc02d"
                                      d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12	s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20	s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" />
                                <path fill="#e53935" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039	l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" />
                                <path fill="#4caf50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36	c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" />
                                <path fill="#1565c0"
                                      d="M43.611,20.083L43.595,20L42,20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571	c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z" />
                            </svg>

                            LOG IN with Google
                        </a>

                    </div>
                    <div class="gt-form-main">
                        <h2> <span>LOG IN with email</span> </h2>

                        <div class="gt-form-group">
                            <div class="form-group mt-form mb-0">
                                <input v-model="log_Email" type="text" class="form-control border0bottom" autocomplete="off" name="log_Email" id="loginEmail" placeholder="Enter your email">
                            </div>
                            <div class="form-group mt-form mb-0">
                                <input v-model="log_Password" type="password" class="form-control border0top password-field" autocomplete="off" name="log_Password" id="loginPassword" placeholder="Enter your password">
                                <span toggle=".password-field" class="far fa-eye field-icon toggle-password" @click="switchVisibilityLogin"></span>
                            </div>
                            <input type="hidden" name="current_url_" id="current_url_" value="@Request.Url.ToString()" />
                            <div id="div_ErrorLogin" style="color:red; font-size:18px; text-align:left; padding:5px;"></div>
                            <div class="mt-35">
                                <button @click="ValidateLogin" class="theme-btn-lite"> Log in </button>
                            </div>

                        </div>

                    </div>


                    <div class="gt-form-footer">
                        <a href="#" class="gt-form-forgot-password" data-dismiss="modal" data-toggle="modal" id="forgotpassword" @click="openForgotpassword">Forgot password?</a>

                        <p class="gt-form-have-account">Don’t have an account? <a data-dismiss="modal" data-toggle="modal" id="Signup" data-target="#signup" href="#">Sign up</a> </p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="modal fade" id="forgot-password-modal" tabindex="-1" aria-labelledby="shareModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog">
            <div class="modal-content modal-content-radius">
                <div class="modal-header p-0 border-0">
                    <button type="button" class="close p-2 mb-0 mr-2 ml-auto mt-0" data-dismiss="modal" aria-label="Close">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 1L7 7L13 13" stroke="#1E2437" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M1 13L7 7L1 1" stroke="#1E2437" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
                <h5 class="modal-title forgot-password-title resetPwdDiv" id="staticBackdropLabel">Forgot Password</h5>
                <div class="modal-body resetPwdDiv">
                    <p class="forgot-password-text">
                        Enter the email address associated with your account and we will send you an email to reset your password. <br />
                    </p>
                    <div class="form-group margintop-30">
                        <input class="form-control max-100" type="email" v-model="resetemail" autocomplete="off" name="resetEmail" id="resetEmail" placeholder="Enter your email">
                    </div>
                    <button class="theme-btn-lite mt-3" @click="Resetpassword">Send Instructions</button>
                </div>
                <div class="resetPwdDivSuccess divHide" id="resetPwdDivEmailSent">
                    <h2 class="modal-title forgot-password-title">Email sent</h2>
                    <div class="modal-body">
                        <p class="forgot-password-text">
                            An email has been sent with instructions for resetting your password. If it doesn't show up, please check your spam folder.
                        </p>
                        <br />
                        <a href="#" class="theme-btn-lite mt-3" data-dismiss="modal">Close</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade gt-md-modal mt-generic-error-popup mt-generic-popup-design" id="mt-generic-error-popup-for-main-login" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" style="margin-left: -7px; z-index: 9999999999 !important">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="gt-md-modal-header">
                    <h2> Oops! </h2>
                    <div class="gt-modal-close" @click="CloseModalandLoader">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" width="14" height="14">
                            <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 13 1 L 7 7 L 13 13" />
                            <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 1 13 L 7 7 L 1 1" />
                        </svg>
                    </div>
                </div>
                <!-- gt-md-modal-header -->
                <div class="gt-md-modal-content text-center">
                    <div class="mb-4 mt-2">
                        <p class="position-relative d-inline-block">
                            <span id="error-text" class="error-text">
                                We can't find an account for that email.

                                If you've used GroupTogether before, you might have created an account on our Australian website.

                                To collect money for gifts in the US, you'll need to<a href="javascript:void(0);" @click="TakeToSignUp"> create a new account</a>. Or to access your old cards on our Australian site, you can <a href="javascript:void(0);" @click="TaketoAu">login here</a>.
                            </span>
                        </p>
                    </div>
                    <div>
                        <a href="javascript:void(0);" @click="CloseModalandLoader" class="theme-btn-lite" data-dismiss="modal">OK</a>
                    </div>
                </div>
                <!-- gt-md-modal-content -->
            </div>
        </div>
    </div>

</template>
<!-- template html -->
<!--script -->
<script>

    export default {
        name: 'SignupPopup',
        props: {

        },
        components: {

        },
        data() {

            return {
                resetemail: "",
                log_Email: "",
                log_Password: "",
                reg_Email: "",
                reg_FName: "",
                reg_LName: "",
                reg_Password: "",
                reg_CPassword: "",
                displayLoaderToLogin: false

            }
        },
        mounted: function () {
            $("#signup").modal("show");
        },
        methods: {
            validateResetpassword() {
                var EmailFor = this.resetemail;
                if ($('#resetemail').val() == "") {
                    ShowErrorPopUp("Please specify a valid email address.");
                    $('#resetemail').focus();
                } else {
                    $.ajax({
                        type: "POST",
                        url: '/api/collectionservices/ForgetPasswordSocialCheck?Email=' + EmailFor,
                        data: { email: resetemail.value },
                        success: function (result) {
                            HideLoadScreen();
                            if (result.Message == "Success") {
                                ShowErrorPopUp("This account is created using social media login");
                            } else if (result.Message == "NotSocialEmail") {
                                this.$emit('showLoadScreen');
                                var email = this.resetemail;
                                var url = window.location.href;
                                $.ajax({
                                    type: "POST",
                                    url: "../Account/Resetpassword",
                                    data: { email: email, url: url },
                                    success: function (result) {

                                        if (result != "_Successful") {
                                            window.parent.ShowErrorPopUp("Sorry, we don't recognise that email address. Please try again or enter a new email address.");
                                        } else {
                                            $(".resetPwdDiv").addClass("divHide");
                                            $(".resetPwdDivSuccess").removeClass("divHide");
                                        }
                                    }
                                });
                                this.$emit('hideLoadScreen');
                            }
                            else {
                                ShowErrorPopUp("Sorry, we don't recognise that email address. Please try again or enter a new email address.");
                            }
                        }
                    });
                }
            },
            Resetpassword() {
                var EmailFor = this.resetemail;
                var url = window.location.href;
                if (EmailFor == "") {
                    window.parent.ShowErrorPopUp("Please specify a valid email address.");
                } else {
                    this.$emit('showLoadScreen');
                    $.ajax({
                        type: "POST",
                        url: '/api/collectionservices/ForgetPasswordSocialCheck?Email=' + EmailFor,
                        data: { email: EmailFor },
                        success: function (result) {
                            if (result.Message == "Success") {
                                window.parent.ShowErrorPopUp("This account is created using social media login");
                            } else if (result.Message == "NotSocialEmail") {

                                $.ajax({
                                    type: "POST",
                                    url: "../Account/Resetpassword",
                                    data: { email: EmailFor, url: url },
                                    success: function (result) {

                                        if (result != "_Successful") {
                                            window.parent.ShowErrorPopUp("Sorry, we don't recognise that email address. Please try again or enter a new email address.");
                                        } else {
                                            $(".resetPwdDiv").addClass("divHide");
                                            $(".resetPwdDivSuccess").removeClass("divHide");
                                        }
                                    }
                                });

                            }
                            else {
                                ShowErrorPopUp("Sorry, we don't recognise that email address. Please try again or enter a new email address.");
                            }
                        }
                    });
                }
                this.$emit('hideLoadScreen');
            },
            openForgotpassword() {
                $("#signin").modal('hide');
                $(".resetPwdDiv").removeClass("divHide");
                $("#resetPwdDivemailSent").addClass("divHide");
                $('#resetemail').val('');
                $('#forgot-password-modal').modal();
            },
            switchVisibilityLogin() {
                const passwordField = document.querySelector('#loginPassword')
                if (passwordField.getAttribute('type') === 'password') passwordField.setAttribute('type', 'text')
                else passwordField.setAttribute('type', 'password')
            },
            TakeToSignUp() {
                this.displayLoaderToLogin = false;
                $('#mt-generic-error-popup-for-main-login').modal('hide');
                $('#signin').modal('hide');
                $('#signup').modal();
            },
            TaketoAu() {
                this.$emit('hideLoadScreen');
                window.parent.RedirecttoAuSite();
            },
            CloseModalandLoader() {
                this.displayLoaderToLogin = false;
                $('#mt-generic-error-popup-for-main-login').modal('hide');
            },
            switchVisibilitySignup() {
                const passwordField = document.querySelector('#reg_Password')
                if (passwordField.getAttribute('type') === 'password') passwordField.setAttribute('type', 'text')
                else passwordField.setAttribute('type', 'password')
                const CpasswordField = document.querySelector('#reg_CPassword')
                if (CpasswordField.getAttribute('type') === 'password') CpasswordField.setAttribute('type', 'text')
                else CpasswordField.setAttribute('type', 'password')
            },
            closemodal() {
                this.$emit('hideModal');
            },
            StopLoadScreen() {

            },
            async Showpope() {
                this.$emit('showLoadScreen');
            },
            async ValidateLogin() {
                var that = this
                this.displayLoaderToLogin = true;
                var loginEmail = this.log_Email;
                var loginPassword = this.log_Password;
                var errorDiv = document.getElementById("div_ErrorLogin");

                if (loginEmail == "") {
                    errorDiv.innerHTML = "Email is required";
                    errorDiv.className = "divDisplay";
                    this.displayLoaderToLogin = false;

                } else if (loginPassword == "") {
                    errorDiv.innerHTML = "Password is required";
                    errorDiv.className = "divDisplay";
                    this.displayLoaderToLogin = false;
                } else {
                    $.ajax({
                        type: "POST",
                        url: "/home/checkdomain",
                        data: { email: loginEmail },
                        success: function (result) {
                            if (result == "success") {
                                $.ajax({
                                    type: "POST",
                                    url: "/Auth/login",
                                    data: { "Email": loginEmail, "Password": loginPassword, "RememberMe": false, "url": "" },
                                    success: function (loginresult) {
                                        if (loginresult.Status) {
                                            $("#signin").modal('hide');
                                            $.ajax({
                                                url: "/Account/GetSavedUrl",
                                                type: "GET",
                                                dataType: "json",
                                                contentType: "application/json",
                                                success: function (result) {
                                                    if (result == "Failed") {
                                                        window.location.reload();
                                                    } else {
                                                        window.location.href = result;
                                                    }
                                                },
                                                error: function (err) {
                                                    //hide loader
                                                    errorDiv.innerHTML = "Error getting Info form Server";
                                                    this.$emit('hideLoadScreen');
                                                }
                                            });
                                        } else if (loginresult == "facebook") {
                                            var errorDiv = document.getElementById("div_ErrorLogin");
                                            errorDiv.innerHTML = "Invalid, please login using Facebook.";
                                            loginEmail.value = "";
                                            loginPassword.value = "";
                                            this.$emit('hideLoadScreen');
                                        } else if (loginresult == "google") {
                                            var errorDiv = document.getElementById("div_ErrorLogin");
                                            errorDiv.innerHTML = "Invalid, please login using Google.";
                                            loginEmail.value = "";
                                            loginPassword.value = "";
                                            that.displayLoaderToLogin = false
                                        } else if (loginresult.Error == "EmailNotVerified") {
                                            $('#confirmEmailModal').modal();
                                            window.location.reload();
                                        } else if (loginresult.Error == "EmailCredentialsMissing") {
                                            $('#mt-generic-error-popup-for-main-login').modal();
                                            that.displayLoaderToLogin = false
                                        }
                                        else if (loginresult.Error == "InvalidCredentials") {
                                            window.parent.ShowErrorPopUp("Your password is incorrect");
                                            that.displayLoaderToLogin = false
                                        } else if (loginresult.Error == 'InvalidCredentialsGoogle') {
                                            window.parent.ShowErrorPopUp("Your password is incorrect.<br>Hint: Try logging in using Google.");
                                            that.displayLoaderToLogin = false
                                        } else if (loginresult.Error == 'InvalidCredentialsFacebook') {
                                            window.parent.ShowErrorPopUp("Your password is incorrect.<br>Hint: Try logging in using Facebook.");
                                            that.displayLoaderToLogin = false
                                        }
                                        else {
                                            var errorDiv = document.getElementById("div_ErrorLogin");
                                            this.ShowErrorPopUp("Invalid user name or password.");
                                            loginEmail.value = "";
                                            loginPassword.value = "";
                                            this.$emit('hideLoadScreen');
                                        }
                                    },
                                    error: function (e) {
                                        this.$emit('hideLoadScreen');
                                        console.log(e);
                                    }
                                });
                            } else {
                                this.$emit('hideLoadScreen');
                                this.ShowErrorPopUp("Sorry you cannot login using this email address.");
                            }
                        }
                    });
                    window.parent.LoadScreenStop();
                }

            },
            async Validate_Registration() {
                this.$emit('showLoadScreen');
                var Email = this.reg_Email;
                var Password = this.reg_Password;
                var Fname = this.reg_FName;
                var Lname = this.reg_LName;
                var Cpassword = this.reg_CPassword;
                var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!#@\$%\^-_&\*])(?=.{6,})");

                var errorDiv = document.getElementById("div_ErrorReg");
                if (Fname == "") {
                    errorDiv.innerHTML = "First Name is required";
                    errorDiv.className = "divDisplay";
                    this.$emit('hideLoadScreen');
                }
                else if (Email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/gi)) {
                    errorDiv.innerHTML = "Invalid Email address";
                    errorDiv.className = "divDisplay";
                    this.$emit('hideLoadScreen');
                }
                else if (Lname == "") {
                    errorDiv.innerHTML = "Last name is required.";
                    errorDiv.className = "divDisplay";
                    this.$emit('hideLoadScreen');
                } else if (Email == "") {
                    errorDiv.innerHTML = "Email address is required.";
                    errorDiv.className = "divDisplay";
                    this.$emit('hideLoadScreen');
                }
                else if (Password == "") {
                    errorDiv.innerHTML = "You must specify a password.";
                    errorDiv.className = "divDisplay";
                    this.$emit('hideLoadScreen');
                } else if (Password.length < 6) {
                    errorDiv.innerHTML = "The password must contain a minimum of six characters and at least one uppercase letter, one lowercase letter, one number, and one special character.";
                    errorDiv.className = "divDisplay";
                    this.$emit('hideLoadScreen');
                }
                else if (Cpassword == "") {
                    errorDiv.innerHTML = "Please confirm your password.";
                    errorDiv.className = "divDisplay";
                    this.$emit('hideLoadScreen');

                } else if (Password != Cpassword) {
                    errorDiv.innerHTML = "Passwords must match.";
                    errorDiv.className = "divDisplay";
                    this.$emit('hideLoadScreen');

                } else if (!Password.match(strongRegex)) {
                    errorDiv.innerHTML = "The password must contain a minimum of six characters and at least one uppercase letter, one lowercase letter, one number, and one special character.";
                    errorDiv.className = "divDisplay";
                    this.$emit('hideLoadScreen');

                }
                else {
                    window.parent.LoadScreenShow();
                    await $.ajax({
                        type: "POST",
                        url: "/home/checkdomain",
                        data: { email: this.reg_Email },
                        success: async function (result) {
                            if (result == "success") {
                                var Pageurl = "/Auth/RegisterUserModal";
                                await $.ajax({
                                    type: "POST",
                                    url: Pageurl,
                                    data: { fname: Fname, lname: Lname, email: Email, password: Password, url: "", CollectionID: "" },
                                    success: async function (result) {
                                        if (result == "Phone number is already blocked.") {                                           
                                            window.parent.ShowErrorPopUp("This email is already in use.");
                                            window.parent.LoadScreenStop();
                                            window.location.reload();
                                            var errorDiv = document.getElementById("div_ErrorReg");
                                            errorDiv.innerHTML = "Security: An error has occurred. Please contact support@grouptogether.com.";
                                            errorDiv.className = "divDisplay";
                                        }
                                        else if (result == "Success") {
                                            $("#signup").modal('hide');
                                            await $.ajax({
                                                url: "/Account/GetSavedUrl",
                                                type: "GET",
                                                dataType: "json",
                                                contentType: "application/json",
                                                success: function (result) {
                                                    if (result == "Failed") {
                                                        window.location.reload();
                                                    } else {
                                                        window.location.href = result;
                                                    }
                                                },
                                                error: function (err) {

                                                    console.log("Error while getting info.");
                                                }
                                            });
                                        } else if (result == "Duplicate") {

                                            window.parent.ShowErrorPopUp("This email is already in use.");
                                            window.parent.LoadScreenStop();
                                            window.location.reload();
                                            var errorDiv = document.getElementById("div_ErrorReg");
                                            errorDiv.innerHTML = "This email is already in use.";
                                            errorDiv.className = "divDisplay";
                                        }

                                        else {

                                            var errorDiv = document.getElementById("div_ErrorReg");
                                            errorDiv.innerHTML = "This email is already in use.";
                                            errorDiv.className = "divDisplay";
                                        }
                                    }
                                });
                            } else {

                                errorDiv.innerHTML = "Sorry we cannot create an account using this email address.";
                                errorDiv.className = "divDisplay";
                            }
                        }
                    });
                    //hide loader
                    /* this.$emit('hideLoadScreen');*/
                    window.parent.LoadScreenStop();
                }
            },
            async SignIn() {
                var rememberMe = true;
                var loginEmail = this.log_Email;
                var loginPassword = this.log_Password;
                /*$('#codeEmail').val(loginEmail);*/
                $.ajax({
                    type: "POST",
                    url: "/loginModal/account",
                    data: JSON.stringify({ login: { Email: loginEmail, Password: loginPassword, RememberMe: rememberMe }, url: "", page: "1" }),
                    contentType: 'application/json',
                    success: function (loginresult) {
                        if (loginresult == "Success") {
                            $("#signin").modal('hide');
                            $.ajax({
                                type: "POST",
                                url: "/Account/CheckMobileVerification",
                                data: { email: loginEmail.value },
                                async: false,
                                cache: false,
                                timeout: 20000,
                                success: function (result) {
                                    if (result == 'verified') {
                                        $.ajax({
                                            url: "/Account/GetSavedUrl",
                                            type: "GET",
                                            dataType: "json",
                                            contentType: "application/json",
                                            success: function (result) {
                                                if (result != "Failed") {
                                                    window.location.href = result;
                                                } else {
                                                    window.location.reload();
                                                }
                                            },
                                            error: function (err) {
                                                //hide loader
                                                HideLoadScreen();
                                                console.log("Error while getting info.");
                                            }
                                        });
                                    }
                                    else {
                                        window.parent.location.reload();
                                    }
                                },
                                error: function (result) {
                                    HideLoadScreen();

                                }
                            });
                        } else if (loginresult == "facebook") {

                            var errorDiv = document.getElementById("div_ErrorLogin");
                            errorDiv.innerHTML = "Invalid, please login using Facebook.";
                            loginEmail.value = "";
                            loginPassword.value = "";
                        } else if (loginresult == "google") {

                            var errorDiv = document.getElementById("div_ErrorLogin");
                            errorDiv.innerHTML = "Invalid, please login using Google.";
                            loginEmail.value = "";
                            loginPassword.value = "";
                        }
                        else {

                            var errorDiv = document.getElementById("div_ErrorLogin");
                            errorDiv.innerHTML = "Invalid user name or password.";
                            loginEmail.value = "";
                            loginPassword.value = "";
                        }
                    },
                    error: function (e) {

                        console.log(e);
                    }
                });
            },
            ShowErrorPopUp(message) {
                $("#error-text").html(message);
                $("#mt-generic-error-popup").modal();
            }
        }
    }
</script>
<!--script -->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
